import { Box, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import SkipNextIcon from "@mui/icons-material/SkipNext";
import MenuIcon from "@mui/icons-material/Menu";

const MediaPlayBack1Widget = ({ widget, onValueUpdate }) => {
  const [v0, setV0] = useState({});
  const [isPlaying, setIsPlaying] = useState(false);
  const [w1, setW1] = useState({});

  useEffect(() => {
    setV0(widget);
    if (widget?.items?.$w1) {
      setIsPlaying(Boolean(widget.items.$w1.value));
    }
    return () => {};
  }, [widget]);

  const handleValueUpdate = (data) => {
    const updatedWidget = {
      ...v0.items.$w1,
      value: data,
    };
    setIsPlaying(Boolean(data));
    onValueUpdate(updatedWidget);
  };

  const handlePlayPause = () => {
    handleValueUpdate(!isPlaying);
  };

  const handlePrevious = () => {
    // Trigger previous track action
    if (v0.items.$w1?.onPrevious) {
      onValueUpdate({
        ...v0.items.$w1,
        action: "previous",
      });
    }
  };

  const handleNext = () => {
    // Trigger next track action
    if (v0.items.$w1?.onNext) {
      onValueUpdate({
        ...v0.items.$w1,
        action: "next",
      });
    }
  };

  const handleMenu = () => {
    // Trigger menu action
    if (v0.items.$w1?.onMenu) {
      onValueUpdate({
        ...v0.items.$w1,
        action: "menu",
      });
    }
  };

  const handleMouseEvents = (event) => {
    event.stopPropagation();
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        position: "relative",
        gap: 1,
        px: 1,
      }}
      onMouseDown={handleMouseEvents}
      onMouseUp={handleMouseEvents}
      onTouchStart={handleMouseEvents}
      onTouchEnd={handleMouseEvents}
      onClick={handleMouseEvents}
    >
      <IconButton
        onClick={handleMenu}
        size="small"
        sx={{ color: "primary.main" }}
      >
        <MenuIcon />
      </IconButton>

      <IconButton
        onClick={handlePrevious}
        size="small"
        sx={{ color: "primary.main" }}
      >
        <SkipPreviousIcon />
      </IconButton>

      <IconButton
        onClick={handlePlayPause}
        size="medium"
        sx={{
          color: "primary.main",
          "&:hover": {
            backgroundColor: "rgba(25, 118, 210, 0.04)",
          },
        }}
      >
        {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
      </IconButton>

      <IconButton
        onClick={handleNext}
        size="small"
        sx={{ color: "primary.main" }}
      >
        <SkipNextIcon />
      </IconButton>
    </Box>
  );
};

export default MediaPlayBack1Widget;
